module.exports = __webpack_public_path__ + "static/media/hotel3.3f5188da.png";